import React from 'react';
import { Switch, Route, withRouter } from 'react-router-dom';
import { PageWrapper, PageContainer } from 'modules/common/Elements';

import LoadingIcon from 'modules/common/LoadingIcon';
import { routes } from 'constants/routes';
import Home from 'modules/home/Home';
import BookerInfoBox from 'modules/component/Booker/InfoBox/BookerInfoBox';
import { checkDeviceType } from 'utils/helpers/helpers';

const MainLayout = () => {
  return (
    <>
      {checkDeviceType()?.device?.type === 'mobile' ? (
        <PageContainer>
          <React.Suspense fallback={<LoadingIcon />}>
            <Switch>
              <Route path={routes.HOME} component={Home} exact />
              <Route path={routes.BOOKERINFO} component={BookerInfoBox} />
            </Switch>
          </React.Suspense>
        </PageContainer>
      ) : (
        <PageWrapper>
          <React.Suspense fallback={<LoadingIcon />}>
            <Switch>
              <Route path={routes.HOME} component={Home} exact />
              <Route path={routes.BOOKERINFO} component={BookerInfoBox} />
            </Switch>
          </React.Suspense>
        </PageWrapper>
      )}
    </>
  );
};

export default withRouter(MainLayout);
